export const SCHEMA_NAME = "CivilPapersPeople";

export const FIELDS = {
  CIVIL_PAPER_DEFENDANT_ID: "civilPaperDefendantID",
  CIVIL_PAPER_ID: "civilPaperID",
  DATE_ADDED: "dateAdded",
  TIME_ADDED: "timeAdded",
  USER: "user",
  BIO_ID: "bioID",
  JACKET_ID: "jacketID",
  PERSON_TO_SERVE_BUSINESS_ID: "personToServeBusinessID",
  COMMENTS: "comments",
  PERSON_IS_BUSINESS: "personIsBusiness",
  INDIVIDUAL_BUSINESS_NAME: "individualBusinessName",
  SEQUENCE: "sequence",
  PRIMARY_PLAINTIFF: "primaryPlaintiff",
  PRIMARY_DEFENDANT: "primaryDefendant",
  SERVE_THIS_PERSON: "serveThisPerson",
  ATTORNEY_ID: "attorneyID",
  CREATOR_STAFF_ID: "creatorStaffID",
  PERSON_TO_SERVE_TYPE: "personToServeType",
  ATTORNEY_ADDRESS_BOOK_ID: "attorneyAddressBookID",
  USE_ALIAS: "useAlias",
  BIO_ALIAS_ID: "bioAliasID",
  JACKET_BUSINESS_ID: "jacketBusinessID",
  CPP_KEY: "cppKey",
};
